import { IComponentOptions } from "angular";
import { DepreciationEditController } from "./controller";

export const vsComponentName = "machineDetailDepreciationEdit";

export const MachineDetailDepreciationEditComponentOptions: IComponentOptions =
  {
    controller: DepreciationEditController,
    template: require("!html-loader!./index.html").default,
    controllerAs: "stateController",
    bindings: {
      machine: "<",
      defaultSetting: "<",
      depreciation: "<",
      returnSubmitState: "<",
      returnCancelState: "<",
    
    },
  };
